import hamletClient from 'modules/hamlet';
import type { TaxRate } from 'modules/data/taxRates/model';

export default async (countryCode: string, stateKey: string): Promise<TaxRate> =>
  (
    await hamletClient.get(`1.0/public/order/taxrate/${countryCode}`, {
      params: { stateKey },
    })
  ).data;
